import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { TransitionPreventorDirective } from '../../shared/directives/transition-preventor.directive';
@Component({
  selector: 'app-switch',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TransitionPreventorDirective],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
})
export class SwitchComponent {
  @Input() noInteraction: boolean;
  @Input() small: boolean;
  @Input() smallish: boolean;
}
